
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(0 1)","stroke":"currentColor","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('rect',{attrs:{"x":"1.875","y":".469","width":"15","height":"15","rx":"1.5"}}),_c('path',{attrs:{"d":"M.938 3.281h1.875M.938 6.094h1.875M.938 8.906h1.875M.938 11.719h1.875"}}),_c('ellipse',{attrs:{"cx":"7.5","cy":"5.391","rx":"1.406","ry":"1.641"}}),_c('path',{attrs:{"d":"M7.5 7v4.75m4-3.719v3.75M10.375 3.75v2.944c0 .518.92.937.938.937h.3c.517 0 .937-.2.937-.937V3.75"}})])])
          )
        }
      }
    